module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_1-86a4f6afe033f73369fdf8d961a3ba93.jpg";